import { RouteRecordRaw } from 'vue-router';
import UserManagement from '@/features/admin/components/UserManagement.vue';
import { withAuthLayoutAndRoles } from '../utils/routeHelpers';

export const adminRoutes: RouteRecordRaw[] = [
  withAuthLayoutAndRoles({
    path: '/admin/users',
    name: 'UserManagement',
    component: UserManagement
  }, ['admin'])
]; 